// Mirror of Shared/Calculators/FormResolver.cs.
import type { CalcDef, Field } from "./types.js";

export function defaults(def: CalcDef): Record<string, string> {
  const form: Record<string, string> = {};
  for (const f of def.fields) {
    if (f.kind === "select") {
      form[f.key] = f.defaultChoice ?? (f.choices && f.choices.length ? f.choices[0].value : "");
    } else {
      form[f.key] = String(f.default ?? 0);
    }
  }
  return form;
}

export function merge(def: CalcDef, overrides: Record<string, string>): Record<string, string> {
  const form = defaults(def);
  for (const f of def.fields) {
    if (f.key in overrides && overrides[f.key] != null) form[f.key] = overrides[f.key];
  }
  return form;
}

export function toInputs(def: CalcDef, form: Record<string, string>): Record<string, number> {
  const inputs: Record<string, number> = {};
  for (const f of def.fields) {
    if (f.kind === "select") {
      const val = f.key in form ? form[f.key] : f.defaultChoice;
      const choice = findChoice(f, val) ?? (f.choices && f.choices.length ? f.choices[0] : undefined);
      if (choice) for (const k of Object.keys(choice.set)) inputs[k] = choice.set[k];
    } else {
      let num = f.default ?? 0;
      if (f.key in form) {
        const parsed = parseFloat(form[f.key]);
        if (!Number.isNaN(parsed)) num = parsed;
      }
      if (f.min != null && num < f.min) num = f.min;
      if (f.max != null && num > f.max) num = f.max;
      inputs[f.key] = num;
    }
  }
  return inputs;
}

function findChoice(f: Field, value: string | undefined): Choice | undefined {
  if (!f.choices || value == null) return undefined;
  return f.choices.find((c) => c.value === value);
}

type Choice = NonNullable<CalcDef["fields"][number]["choices"]>[number];
